import { render, staticRenderFns } from "./SupplierInfo.vue?vue&type=template&id=7331a0f2&scoped=true"
import script from "./SupplierInfo.vue?vue&type=script&lang=js"
export * from "./SupplierInfo.vue?vue&type=script&lang=js"
import style0 from "./SupplierInfo.vue?vue&type=style&index=0&id=7331a0f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7331a0f2",
  null
  
)

export default component.exports